import { render, staticRenderFns } from "./addChainSupplier.vue?vue&type=template&id=04da566e&scoped=true"
import script from "./addChainSupplier.vue?vue&type=script&lang=js"
export * from "./addChainSupplier.vue?vue&type=script&lang=js"
import style0 from "./addChainSupplier.vue?vue&type=style&index=0&id=04da566e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04da566e",
  null
  
)

export default component.exports